/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Case_NegotiationInputs */

const en_stage_case_negotiation = /** @type {(inputs: Stage_Case_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const pt_br2_stage_case_negotiation = /** @type {(inputs: Stage_Case_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociação`)
};

/**
* | output |
* | --- |
* | "Negotiation" |
*
* @param {Stage_Case_NegotiationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_case_negotiation = /** @type {((inputs?: Stage_Case_NegotiationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Case_NegotiationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_case_negotiation(inputs)
	return pt_br2_stage_case_negotiation(inputs)
});